import type { ReactNode } from 'react';
import { editPage } from '../brand/editPages';
import type { EditPageKey } from '../brand/paths';

/** A section's side-menu label (EDIT_PAGES), which also names its region. */
export function editSectionLabel(page: EditPageKey, id: string): string {
  const section = editPage(page).sections.find((s) => s.id === id);
  if (!section) throw new Error(`No "${id}" section on the ${page} page`);
  return section.label;
}

/**
 * One side-menu section of an Edit Brand Workspace page (web.md §6.1): the anchor its menu entry
 * scrolls to and focuses (`tabIndex={-1}`), named by its menu label, kept clear of the top edge when
 * it lands (`scroll-mt-6`).
 */
export function EditSection({ page, id, children }: { page: EditPageKey; id: string; children: ReactNode }) {
  return (
    <section id={id} tabIndex={-1} aria-label={editSectionLabel(page, id)} className="scroll-mt-6 rounded-xl">
      {children}
    </section>
  );
}
